import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { BuildDialogData } from '@app/shared/components/dialogs/build-dialog/build-dialog.data';
//import { Component, Inject, OnDestroy, OnInit , Input ,Output} from '@angular/core';
import { Store } from '@src/store';
import { packagesActions } from '../../../../../store/reducers/packagesReducer';

@Component({
    selector: 'build-dialog',
    template: require('./build-dialog.component.html'),
    styles: [require('./build-dialog.component.scss')]
})
export class BuildDialogComponent {

    public packageList: any[] = [];
    public showAdditionalInfoFiled: boolean = false;
    public additionalInfoFeildText: string = 'Tasks/Commit/Tag';
    public requests: any[] = [];
    public reqData: any;
    public additionalInfoError: string;
    minAdditionalInfoLength: number = 2;

    constructor(@Inject(MAT_DIALOG_DATA) public data: BuildDialogData, public store: Store) {
        this.packageList = [...[{ name: 'None' }], ...data.packages];
        this.reqData = data
    }



    public onSelectedSourceChange(event: any): void {
        if (event.isUserInput) {
            this.showAdditionalInfoFiled = ((['3', '5', '7', '8'].indexOf(event.source.value)) == -1) ? false : true;
            switch (event.source.value) {
                case '3':
                    this.additionalInfoFeildText = 'Commit';
                    break;
                case '5':
                    this.additionalInfoFeildText = 'Label';
                    break;
                case '7':
                    this.additionalInfoFeildText = 'Tasks list';
                    break;
                case '8':
                    this.additionalInfoFeildText = 'Tag';
                    break;
                default:
                    this.additionalInfoFeildText = 'Tasks/Commit/Tag';
            }
        }

    }

    additionalInfoChanged() {
        this.additionalInfoError = '';
    }
    validateBeforeBuild() {
        if (this.showAdditionalInfoFiled) {
            if (this.reqData.additionalInfo.length < this.minAdditionalInfoLength) {
                this.additionalInfoError = "Please enter a valid " + this.additionalInfoFeildText + " (" + this.minAdditionalInfoLength.toString() + " chars minimum)";

                return;
            }
        }
        document.getElementById('btnCloseDialog').click();

    }

    async onBuild() {


        var res = this.store.dispatch({
            type: packagesActions.GET_PACKAGES_BY_WILDCARD_AND_LIMIT,
            payload: { projectId: this.reqData.projectId, wildcard: 'commit', limit: 5 }
        });

        res = res;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/build-dialog/build-dialog.component.ts